export default __webpack_public_path__ + "static/media/reward-polygen.bfdb42c4.png";